import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Box, Grid, TextField } from "@mui/material";

import ReportePagina from "../../components/common/ReportePagina";
import { getsAreaObjetivoCriterioResumenView } from "../../services/modeloService";

// Reporte de Modelos: cuanto tiene definido cada modelo de intervencion. Una
// intervencion se compone de areas, cada area de objetivos, y cada objetivo de
// criterios de evaluacion; de ahi sale el conteo.
//
// El detalle viene a nivel de criterio (una fila por criterio), asi que el
// conteo por modelo se arma en el navegador.
const Modelos = () => {
    const [filtro, setFiltro] = useState("");
    const [detalle, setDetalle] = useState([]);
    const [cargando, setCargando] = useState(true);

    const fetchResults = useCallback(async () => {
        setCargando(true);

        await getsAreaObjetivoCriterioResumenView({})
            .then((data) => {
                setDetalle(data || []);
                setCargando(false);
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err);
            });
    }, [])

    useEffect(() => {
        fetchResults();
    }, [fetchResults])

    // Un Set con un null dentro contaria como un elemento mas, asi que los ids
        // que vengan vacios no se cuentan.
const agrega = (conjunto, valor) => {
        if (valor !== null && valor !== undefined) conjunto.add(valor);
    };

    const porModelo = useMemo(() => {
        const mapa = new Map();

        for (const item of detalle) {
            const codigo = item.codigoModelo;

            if (!mapa.has(codigo)) {
                mapa.set(codigo, {
                    codigoModelo: codigo,
                    modelo: item.modelo,
                    areas: new Set(),
                    objetivos: new Set(),
                    criterios: new Set(),
                });
            }

            const fila = mapa.get(codigo);

            agrega(fila.areas, item.idArea);
            agrega(fila.objetivos, item.idAreaObjetivo);
            agrega(fila.criterios, item.idAreaObjetivoCriterio);
        }

        return Array.from(mapa.values()).map((fila) => {
            const areas = fila.areas.size;
            const objetivos = fila.objetivos.size;
            const criterios = fila.criterios.size;

            return {
                ...fila,
                areas,
                objetivos,
                criterios,
                // Cuantos criterios tiene cada objetivo: es el indicador que
                // dice si el modelo esta bien detallado o se queda corto.
                criteriosPorObjetivo: objetivos > 0 ? (criterios / objetivos).toFixed(1) : "0.0",
            };
        });
    }, [detalle])

    const filas = useMemo(() => porModelo
        .filter((fila) => {
            if (filtro == "") return true;

            return (fila.modelo || "").toLowerCase().includes(filtro.toLower())
                || (fila.codigoModelo || "").toLowerCase().includes(filtro.toLower());
        })
        .sort((a, b) => b.criterios - a.criterios),
    [porModelo, filtro]);

    const columnas = [
        { campo: "codigoModelo", titulo: "Código", ancho: 10, alin: "center" },
        { campo: "modelo", titulo: "Modelo de intervención", ancho: 30 },
        { campo: "areas", titulo: "Áreas", ancho: 10, alin: "center" },
        { campo: "objetivos", titulo: "Objetivos", ancho: 10, alin: "center" },
        { campo: "criterios", titulo: "Criterios", ancho: 10, alin: "center" },
        { campo: "criteriosPorObjetivo", titulo: "Criterios por objetivo", ancho: 15, alin: "center" },
    ];

    return (
        <ReportePagina
            titulo="Cobertura de Intervención por Modelo"
            subtitulo="Cuántas áreas, objetivos y criterios de evaluación tiene definidos cada modelo de intervención."
            cargando={cargando}
            indicadores={[
                { etiqueta: "Modelos", valor: String(porModelo.length), color: "#5b2d8e" },
                { etiqueta: "Áreas", valor: String(porModelo.reduce((s, f) => s + f.areas, 0)), color: "#00796b" },
                { etiqueta: "Objetivos", valor: String(porModelo.reduce((s, f) => s + f.objetivos, 0)), color: "#e07b00" },
                { etiqueta: "Criterios", valor: String(porModelo.reduce((s, f) => s + f.criterios, 0)), color: "#c8102e" },
            ]}
            filtros={
                <Grid container spacing={1}>
                    <Grid item xs={8} sm={4}>
                        <TextField
                            label="Modelo o código"
                            value={filtro}
                            fullWidth
                            size="small"
                            onChange={(event) => setFiltro(event.target.value)}
                        />
                    </Grid>
                </Grid>
            }
            grafico={filas.length ? {
                titulo: "Criterios de evaluación por modelo",
                subtitulo: "A más criterios, más detallado el modelo",
                etiquetas: filas.map((f) => f.codigoModelo),
                valores: filas.map((f) => f.criterios),
            } : null}
            columnas={columnas}
            filas={filas}
        />
    )
}

export default Modelos;